module.exports = __webpack_public_path__ + "img/screen-img-02.01ccf45b.webp";